import React, { memo } from 'react';
import cn from 'classnames';
import Tooltip from '@creditflowresearch/uilib/Tooltip';
import { ICategoryItem } from '@/creditflowresearch/application/League/interfaces';
import { useScorecardContext } from '@/creditflowresearch/application/League/Scorecard/ScorecardContext';

import styles from './categoryItem.module.scss';
import IconCollapse from '@creditflowresearch/uilib/Icon/IconCollapse';
import IconExpand from '@creditflowresearch/uilib/Icon/IconExpand';

const CategoryItem = ({
  hasSubItems,
  data,
  onClick,
  index,
}: ICategoryItem) => {
  const categoryId = 'categoryId' in data ? data.categoryId : data.id;
  const categoryName = 'displayName' in data ? data.displayName : data.name;
  const { state } = useScorecardContext();
  const { expandedCategories } = state;
  const isOpen = expandedCategories.includes(categoryId);

  if (!hasSubItems && !isOpen) {
    return null;
  }

  const IconComponent = isOpen ? IconCollapse : IconExpand;

  return (
    <div
      className={ cn(styles.row, styles.item, {
        [styles.hasSubItems]: hasSubItems,
      }) }
      data-test={ `row[${ index }]` }
      onClick={ onClick }
    >
      <span className={ styles.iconWrapper }>
        { hasSubItems && (
        <IconComponent
          className={ styles.itemIcon }
          data-test="collapseExpandBtn"
        />
) }
      </span>
      <span className={ styles.itemName } data-test="nameCategory">
        <Tooltip
          content={ data.name || '' }
          wrpClassName={ styles.itemTooltipWrp }
          containerClassName={ styles.itemTooltipContainer }
        >
          { categoryName || '' }
        </Tooltip>
      </span>
    </div>
  );
};

export default memo(CategoryItem);
